import { useTranslation } from 'react-i18next'

import { CHARACTER_NON_BREAKING_SPACE } from '../../../constants/common'
import { getQaSelector } from '../../../utils/common'
import { Field } from '../../Field'
import { Link } from '../../Link'
import { getCalendarRequestLabel } from '../Calendar.utils'

import { QA_NAME_CALENDAR_TASK_REQUEST_LINK } from './CalendarTaskRequestLink.constants'

import * as styles from './CalendarTaskRequestLink.module.css'

function CalendarTaskRequestLink({ request }) {
  const { t } = useTranslation()

  // A blank label keeps the link in the control column of the task form.
  return (
    <Field
      shouldAdaptToMobileScreen
      label={CHARACTER_NON_BREAKING_SPACE}
      labelClassName={styles.label}
    >
      <Link
        {...getQaSelector({ value: QA_NAME_CALENDAR_TASK_REQUEST_LINK })}
        className={styles.link}
        to={request.url}
      >
        {t('Calendar.OpenRequestKey', {
          request: getCalendarRequestLabel(request),
        })}
      </Link>
    </Field>
  )
}

export default CalendarTaskRequestLink
